export {
  FontColor,
  FontStyle,
  FontType,
  FontWeight,
  TextAlign,
  TextComponent,
  TextSize,
  TextTransform,
} from './text.component';
